import http from 'axios';
import Recaptcha from 'recaptcha/Recaptcha';

const baseReqConfig = {
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};

function buildFormData(formData, data, baseKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach((key) => {
            buildFormData(formData, data[key], baseKey ? `${baseKey}[${key}]` : key);
        });
    } else {
        formData.append(baseKey, data);
    }
}

export default class HttpService {
    constructor() {}

    /**
     * @param url { string }
     * @param data { object }
     * @returns {Promise<unknown>}
     */
    async doPost(url, data) {
        // get recaptcha token if data.recaptchaAction is provided
        if (data && data?.recaptchaAction) {
            await Recaptcha.appendRecaptchaToken(data);
        }

        return new Promise((resolve, reject) => {
            if (!data || typeof data !== 'object') {
                reject('param: data is not an object');

                return;
            }

            // form data
            let formData = new FormData();

            buildFormData(formData, data);

            http.post(url, formData, baseReqConfig)
                .then(({ data }) => {
                    // track recaptcha validation from api response
                    Recaptcha.trackRecaptchaTokenValidationResult(data);

                    if (data.success) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    /**
     * @param url
     * @param data
     * @returns {Promise<unknown>}
     */
    doGet(url, data) {
        return new Promise((resolve, reject) => {
            let reqConfig = baseReqConfig;

            if (data && typeof data === 'object') {
                reqConfig = Object.assign({ params: data }, baseReqConfig);
            }

            http.get(url, reqConfig)
                .then(({ data }) => {
                    if (data.success) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }
}
